import axios from 'axios'
import { getUserToken } from './functions.js'
import { getServerApi } from './config/deployment'

const envUri = getServerApi();
const DEALS_ENDPOINT = envUri + '/api/deals';
const DOCUMENTS_ENDPOINT = 'details/document';
const SUMMARIES_ENDPOINT = 'summary';

export const upsertDocuments = async ({ dealId, accountId, ownerFileNames }) => {
    const token = await getUserToken();
    const response = await axios.post(`${DEALS_ENDPOINT}/${dealId}/${DOCUMENTS_ENDPOINT}`, {
        accountId,
        ownerFileNames,
        token,
    });

    return response.data.body;
};

export const getDealSummaries = async (accountId) => {
    const token = await getUserToken();
    const response = await axios.get(`${DEALS_ENDPOINT}/${SUMMARIES_ENDPOINT}`, {
        params: {
            token,
            accountId,
        }
    });

    return response.data.body;
};


// WEBPACK FOOTER //
// ./src/dealsRepository.js